import React, { useState, useEffect, useCallback, useRef } from 'react'
import MetaTags from 'react-meta-tags'
import { Container, Row, Col, FormGroup, Label, Input } from 'reactstrap'
import { ToastContainer, toast } from 'react-toastify'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'
import RefreshIcon from '../../assets/images/refresh-icon.png'
import QrCodeBackground from '../../assets/images/qr-code-background.png'
import { Loading } from '../../components/Loading'

import styles from './styles.module.scss'
// import images

import 'chartist/dist/scss/chartist.scss'
import Services from 'services/user'
import instanceService from 'services/instance'
import { RefreshCw, Trash } from 'react-feather'
import { ModalConfirm } from 'components/modalConfirm'
import { Button } from 'react-bootstrap'
import { useInstance } from 'hooks/useInstance'
import { PageHeader } from 'components/pageHeader'
import { SectionCard } from '../EnviarPlanilha/components/SectionCard'

const BILLING_MSG = {
  overdue:
    'Instância inativa. Confira se não há pagamentos em atraso; se estiver tudo em dia, entre em contato com o suporte.',
  inactive_canceled:
    'Instância inativa. Entre em contato com o suporte para regularizar o acesso.'
}

export function InstanceDetailsV2({ match }) {
  const history = useHistory()
  const instanceId = match?.params?.instanceId
  const { getQueue, deleteQueue } = instanceService
  const { confirmRefreshInstance } = useInstance()
  const billingSwalShownRef = useRef(false)

  const [loading, setLoading] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [isLoadingQrcode, setIsLoadingQrcode] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [instanceData, setInstanceData] = useState({ id: instanceId })
  // eslint-disable-next-line no-unused-vars
  const [qrcodeUrl, setQrcodeUrl] = useState(null)
  const [rendered, setRendered] = useState(false)
  const [showRefreshButton, setShowRefreshButton] = useState(false)
  const countQrCode = useRef(0)

  const [showModalConfirm, setShowModalConfirm] = useState(false)

  const [queueCount, setQueueCount] = useState(0)

  const controlInterval = useRef(null)
  const controlIntervalStatus = useRef(null)
  const handleClose = () => {
    setLoading(false)
  }

  const loadInstance = useCallback(async () => {
    if (countQrCode.current >= 1 || isAuthenticated) {
      clearInterval(controlInterval.current)
      clearInterval(controlIntervalStatus.current)
      countQrCode.current = 0
      setIsLoadingQrcode(false)
      setShowRefreshButton(true)
      return
    }
    countQrCode.current = countQrCode.current + 1
    const rawQr = localStorage.getItem('@zapmais-qrcode')
    let data = null
    if (rawQr) {
      try {
        data = JSON.parse(rawQr)
      } catch {
        localStorage.removeItem('@zapmais-qrcode')
      }
    }
    if (data && data?.instanceId && data?.expiration > new Date().getTime()) {
      // O objeto ainda está válido
      const qrTemp = data.qr
      setQrcodeUrl(qrTemp)
      setShowRefreshButton(false)
      setIsLoadingQrcode(false)
      setIsAuthenticated(false)
      return
      // Faça algo com os dados
    } else {
      // O objeto expirou ou não existe
      localStorage.removeItem('@zapmais-qrcode')
    }
    const response = await Services.getQrCodeZapmais({ instanceId })
    if (response.status === 200) {
      if (response.data.connected) {
        setIsLoadingQrcode(false)
        setIsAuthenticated(true)
        clearInterval(controlInterval.current)
        countQrCode.current = 0
        setInstanceData({
          ...instanceData,
          instanceName: response?.data?.user?.name || '',
          instancePhone: response?.data?.user?.phone || '',
          connected: 'Sim'
        })
        localStorage.removeItem('@zapmais-qrcode')
      } else {
        const qr = response?.data?.qr

        const expiration = new Date().getTime() + 20000 // 60 segundos depois da hora atual

        const data = {
          instanceId,
          qr,
          expiration
        }

        localStorage.setItem('@zapmais-qrcode', JSON.stringify(data))
        setQrcodeUrl(response?.data?.qr)
        setShowRefreshButton(false)
        setIsLoadingQrcode(false)
        setIsAuthenticated(false)
      }
      setLoading(false)
      return true
    } else {
      toast.error(
        response?.msg || 'Não foi possível carregar os dados da instância'
      )
      setLoading(false)
      return false
    }
  }, [instanceId, isAuthenticated])

  async function getMessageQueue() {
    try {
      const response = await getQueue({ instanceLocalId: instanceId })
      if (response.status === 200 && response?.data?.count) {
        setQueueCount(response?.data?.count)
      } else {
        setQueueCount(0)
      }
    } catch {
      setQueueCount(0)
    }
  }

  const checkInstanceStatus = useCallback(
    async (load = false) => {
      const response = await Services.getStatusInstance({ instanceId })
      if (response.status === 200) {
        const billing = response.data?.instance_status
        if (billing === 'overdue' || billing === 'inactive_canceled') {
          if (billingSwalShownRef.current) {
            setLoading(false)
            return true
          }
          billingSwalShownRef.current = true
          if (controlInterval.current) clearInterval(controlInterval.current)
          if (controlIntervalStatus.current) {
            clearInterval(controlIntervalStatus.current)
          }
          const rawSub = response.data?.subscription_id
          const subscriptionId =
            typeof rawSub === 'number' ? rawSub : Number(rawSub)
          const hasSubId = Number.isFinite(subscriptionId)
          const text =
            response.data?.msg ||
            BILLING_MSG[billing] ||
            'Instância inativa.'
          Swal.fire({
            icon: 'error',
            title: 'Ops..',
            text,
            confirmButtonText: 'Ver pagamentos da assinatura',
            showConfirmButton: true,
            showCancelButton: false,
            showCloseButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then((res) => {
            if (res.isConfirmed) {
              if (hasSubId) {
                history.push(
                  `/assinaturas?subscriptionId=${subscriptionId}&tab=payments`
                )
              } else {
                history.push('/assinaturas')
              }
            }
          })
          setLoading(false)
          return true
        }
        if (response.data.connected) {
          setIsLoadingQrcode(false)
          setIsAuthenticated(true)
          clearInterval(controlInterval.current)
          clearInterval(controlIntervalStatus.current)
          countQrCode.current = 0
          setInstanceData({
            ...instanceData,
            instanceName: response?.data?.user?.name || '',
            instancePhone: response?.data?.user?.phone || '',
            connected: 'Sim'
          })
          getMessageQueue()
          localStorage.removeItem('@zapmais-qrcode')
        } else {
          if (load) {
            loadInstance()
          }
        }
        setLoading(false)
        return true
      } else {
        toast.error(
          response?.msg || 'Não foi possível carregar os dados da instância'
        )
        setLoading(false)
        return false
      }
    },
    [instanceId, isAuthenticated, history]
  )

  function handleClickRefresh() {
    setIsLoadingQrcode(true)
    setShowRefreshButton(false)
    checkInstanceStatus(true)
    if (controlInterval.current) clearInterval(controlInterval.current)
    if (controlIntervalStatus.current) {
      clearInterval(controlIntervalStatus.current)
    }
    controlInterval.current = setInterval(() => {
      loadInstance()
    }, 60000)
    controlIntervalStatus.current = setInterval(() => {
      checkInstanceStatus()
    }, 10000)
  }

  async function handleRemoveQueue() {
    try {
      setLoading(true)
      const response = await deleteQueue({ instanceLocalId: instanceId })
      setLoading(false)
      setShowModalConfirm(false)
      if (response.status === 200) {
        setQueueCount(0)
        toast.success(response?.data?.msg || 'Mensagens removidas')
      } else {
        toast.error(
          response?.response?.data?.msg ||
            'Não foi possível remover as mensagens da fila'
        )
      }
    } catch {
      setShowModalConfirm(false)
      setLoading(false)
    }
  }

  function handleCancelRemoveQueue() {
    setShowModalConfirm(false)
  }

  useEffect(() => {
    billingSwalShownRef.current = false
  }, [instanceId])

  useEffect(() => {
    if (!rendered) {
      setRendered(true)
    }
    if (instanceId && rendered) {
      checkInstanceStatus(true)
      controlInterval.current = setInterval(() => {
        loadInstance()
      }, 60000)
      controlIntervalStatus.current = setInterval(() => {
        checkInstanceStatus()
      }, 10000)
    }

    return () => {
      clearInterval(controlInterval.current)
      clearInterval(controlIntervalStatus.current)
    }
  }, [rendered])

  return (
    <React.Fragment>
      {loading && <Loading open={loading} handleClose={handleClose} />}
      <ToastContainer />
      <div className={`page-content ${styles.ptb}`}>
        <MetaTags>
          <title>Detalhes da instância Zap+ | Zap+</title>
        </MetaTags>
        <Container fluid>
          <div className={styles.detailsPage}>
            <PageHeader
              title="Detalhes da instância Zap+"
              subtitle="Conecte pelo QR Code, use o token na API e acompanhe a fila de envio desta instância."
            />

            <Row className="g-3 align-items-stretch">
              <Col xs={12} lg={7}>
                <SectionCard
                  title="Dados da instância"
                  subtitle="Campos somente leitura para conferência e integração."
                >
                  <Row>
                    <Col xs={12} md={6} className="mb-3">
                      <FormGroup className="mb-0">
                        <Label>Nome</Label>
                        <Input
                          type="text"
                          name="instanceName"
                          value={instanceData.instanceName || ''}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6} className="mb-3">
                      <FormGroup className="mb-0">
                        <Label>Telefone conectado</Label>
                        <Input
                          type="text"
                          name="instancePhone"
                          value={instanceData.instancePhone || ''}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6} className="mb-3">
                      <FormGroup className="mb-0">
                        <Label>Token (ID da instância)</Label>
                        <Input
                          type="text"
                          name="instanceToken"
                          value={instanceData.id || ''}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6} className="mb-3">
                      <FormGroup className="mb-0">
                        <Label>Conectada</Label>
                        <Input
                          type="text"
                          name="instanceConnected"
                          value={instanceData.connected || 'Não'}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </SectionCard>
              </Col>

              <Col xs={12} lg={5}>
                <SectionCard
                  title="Conexão WhatsApp"
                  subtitle={
                    isAuthenticated
                      ? 'Instância pronta para envio.'
                      : 'Escaneie o QR Code no WhatsApp do celular.'
                  }
                >
              <div className={styles.textHeaderContainer}>
                <h4>
                  {isAuthenticated ? 'Conectado' : 'Leia o QR Code'}
                </h4>
                <h6>
                  {isAuthenticated
                    ? 'Sua instância está conectada; você já pode enviar mensagens pela API.'
                    : 'Abra o WhatsApp no celular, aponte para o código abaixo e conclua o pareamento.'}
                </h6>
              </div>
              <div className={styles.containerQrcode}>
                {isLoadingQrcode ? (
                  <div className={styles.loadingQrcodeContainer}>
                    <div className={`spinner-border`} role="status"></div>
                    <div className={styles.loadingText}>Carregando QR Code</div>
                  </div>
                ) : showRefreshButton ? (
                  <div
                    className={styles.containerRefreshQrcode}
                    onClick={handleClickRefresh}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        handleClickRefresh()
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    <div
                      style={{ color: '#00ac5a' }}
                      className={styles.containerImgRefreshQrcode}
                    >
                      <img
                        src={RefreshIcon}
                        alt="Ícone de refresh"
                        className={styles.iconRefresh}
                      />
                      <img
                        src={QrCodeBackground}
                        alt="qr code background"
                        className={styles.qrCodeBackground}
                      />
                    </div>
                    Clique para recarregar o QR Code
                  </div>
                ) : isAuthenticated ? (
                  <div
                    style={{ color: '#00ac5a' }}
                    className={styles.containerIsAuthenticated}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      viewBox="0 0 512 512"
                      height="40"
                      width="40"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                    </svg>
                  </div>
                ) : (
                  <img src={qrcodeUrl} alt="QR Code para conectar o WhatsApp" />
                )}
              </div>
              {queueCount ? (
                <>
                  <div className={styles.queueCount}>
                    Você possui {queueCount}{' '}
                    {queueCount > 1 ? 'mensagens' : 'mensagem'} na fila de envio
                    desta instância.
                  </div>
                  <div
                    className={`${styles.queueCount} ${styles.queueDelete}`}
                    onClick={() => setShowModalConfirm(true)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        setShowModalConfirm(true)
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    Remover mensagens da fila
                    <Trash size={18} />
                  </div>
                </>
              ) : null}
              <div className={styles.helperTextContainer}>
                <small>
                  Se o QR Code não aparecer, use{' '}
                  <strong>Atualizar instância</strong>.
                </small>
              </div>
              <div className={styles.buttonRefresh}>
                <Button
                  variant="outline-primary"
                  onClick={() => confirmRefreshInstance(instanceId)}
                >
                  Atualizar instância <RefreshCw size={18} className="ms-1" />
                </Button>
              </div>
                </SectionCard>
              </Col>
            </Row>
          </div>
          <ModalConfirm
            showModal={showModalConfirm}
            text="Remover todas as mensagens da fila dessa instância?"
            title="Apagar mensagem da fila"
            onCancel={handleCancelRemoveQueue}
            onConfirm={handleRemoveQueue}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}
